import React from 'react';
import { Store, Home, PackageCheck } from 'lucide-react';
import { getFullAddress } from '../../features/orderDetails/orderUtils';

/**
 * Where a shipment redirected to a pickup point is going, and where it was
 * going before. Read-only: the admin changes it from the actions menu, and a
 * seller only reads it.
 *
 * `delivery.shipping_address` already is the point's address (a copy of it);
 * `delivery.pickup_point` carries what that copy does not say: which point,
 * the customer's original address, and whether the point handed it over.
 *
 * @param {object} props
 * @param {object} props.delivery
 * @param {(props: {label: string, children: React.ReactNode, icon?: React.ComponentType}) => JSX.Element} props.Datum
 */
export const PickupPointDestination = ({ delivery, Datum }) => {
  const info = delivery?.pickup_point;
  if (!info) return null;

  const handedOver = Boolean(info.handed_over_at);

  return (
    <>
      <div className="col-span-1 sm:col-span-2">
        <Datum icon={Store} label="Destino: punto de retiro">
          <span className="text-ninja-green font-bold">{info.pickup_point_name}</span>
          <span className="block">{getFullAddress(delivery.shipping_address)}</span>
          {handedOver && (
            <span className="flex items-center gap-1.5 text-xs text-text-muted mt-1">
              <PackageCheck size={12} />
              Entregado al cliente{info.handed_over_to ? ` · recibió ${info.handed_over_to}` : ''}
            </span>
          )}
        </Datum>
      </div>
      <div className="col-span-1 sm:col-span-2">
        <Datum icon={Home} label="Dirección original del cliente">
          <span className="text-text-secondary">{getFullAddress(info.original_shipping_address)}</span>
        </Datum>
      </div>
    </>
  );
};
